import React, {useState} from "react";
import close from "../../../../images/Close.svg";
import http from "../../../../services/api/utilities/http";
const modal = {
    width:473,
    position:'absolute',
    zIndex:1000,
    background:'white',
    top:'50%',
    left:'50%',
    right:'50%',
    borderRadius:20,
    padding:40,
    transform: 'translate(-50%, -50%)',
    boxShadow:'rgba(0, 0, 0, 0.08)',
}
const closeStyle = {
    cursor:'pointer',
    position: 'absolute',
    right : 40
}

export default function RemoveModal(props) {
    const [name , setName] = useState('')
    const [loading , setLoading] = useState(false)
    const [error , setError] = useState('')
    const remove = () => {
        setLoading(true)
       if(name === props.name){
           http.delete('data_connector/data_pool/'+props.uid)
               .then(res => {
                   setLoading(false)
                   props.getData()
               })
               .catch(err=>{
                   setLoading(false)
                   console.log(err.response)
               })
       }else{
           setLoading(false)
           setError('The name entered does not match the box name')
       }

    }
    const nameHandler = e => {
        setError('')
        setName(e.target.value)
    }
return(
           <>
               <div className="modal-back"></div>
               <div style={modal} className="-modal">
                   <img  onClick={() => props.close()} style={closeStyle} src={close} alt="close"/>
                   <p className="f16 dark-gary fw700">Deleting Data Connector</p>
                   <p className="mt-3 f14 fw300">Please type the connector name you want to remove :</p>
                   <p className="f14 fw600 dark-gary mt-24 mb-3">Name</p>
                   <input onChange={nameHandler} placeholder="Enter a name for this process" type="text"/>
                   <p className="error mt-1">{error}</p>
                   <div className="d-flex mt-32">
                       <div onClick={remove} className={`btn ${name && 'btn-active'} ${loading && 'btn-loading-small'} btn btn-by-loading mr-24`}>
                           <p>delete</p>
                           <p>deleting</p>
                       </div>
                       <div className="btn btn-outline" onClick={() => props.close()}>CLOSE</div>
                   </div>
               </div>
           </>
)
}
